<template>
  <span v-if="workingReward">
    <v-row class="mt-6">
      <v-col cols="12">
        <v-radio-group
          label="Reduction Type"
          v-model="workingReward.feeReductionType"
          dense
          :rules="requiredRule"
          @change="onChange">
            <v-radio v-for="item in Object.entries(FeeReductionTypes)" v-bind:key="item[0]" :value="item[0]" :label="item[1]" :ref="`${item[0]}_Radio`"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row class="mt-6" v-if="workingReward.feeReductionType === 'PARTIAL_FEE'">
      <v-col cols="12">
        <v-text-field
          label="Reduction Amount"
          v-model="workingReward.partialFeeReductionAmount"
          type="number"
          hint="Ex. 3.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="partialFeeReductionAmount"
          ref="partialFeeReductionAmount"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { FeeReductionReward, FeeReductionTypes } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class FeeReductionRewardEditor extends Vue {
  @Prop()
  value!:FeeReductionReward;

  workingReward:FeeReductionReward | null = null;

  // Make visible to template
  FeeReductionTypes:any = FeeReductionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as FeeReductionReward;
  }

  @Watch('workingReward.feeReductionType')
  onFeeReductionTypeChange() {
    if (this.workingReward!.feeReductionType === 'FULL_FEE') {
      this.workingReward!.partialFeeReductionAmount = null;
      this.onChange();
    }
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
